<template>
  <section>
    <GroupTitle />
    <Feature :title="$t('CONSIGNMENT_SUMMARY_REPORT')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="['*' + $t('PLANT_CODE'), $t('DELTA_PN'), $t('BEGIN_DATE'), '*' + $t('PERIOD_TYPE')]">
        <Select filterable v-model="plantCode" style="width: 200px" slot="a">
          <Option v-for="(item, index) in plantList" :value="item" :key="index">{{ item }}</Option>
        </Select>
        <Input v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="b" />
        <DatePicker v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_FROM')"
          slot="c" @on-change="changeDate()"></DatePicker>
        <Select filterable style="width: 200px" v-model="periodTypeValue" slot="d" @on-change="changePeriod($event)">
          <Option v-for="(item, index) in periodTypeList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </FormRow>
      <ButtonRow>
        <Button type="primary" slot="0" @click="search">{{ $t('QUERY') }}</Button>
        <Button type="primary" slot="1" @click="download">{{ $t('DOWNLOAD_EXCEL') }}</Button>
        <Button type="primary" slot="2" @click="clear">{{ $t('CLEAR') }}</Button>
      </ButtonRow>

      <Tabs value="name1" :animated="false">
        <TabPane label="AMT-SUMMARY FOR INVOICE" name="name1">
          <ConsignmentSummaryReportAmtTable :dataList="dataListAmt" :currencyData="currencyData"
            v-if="dataListAmt.length > 0">
          </ConsignmentSummaryReportAmtTable>
          <ConsignmentSummaryReportAmtTableTH :dataList="dataListAmtTH" :currencyData="currencyData"
            v-if="dataListAmtTH.length > 0">
          </ConsignmentSummaryReportAmtTableTH>
        </TabPane>
        <TabPane label="QTY-SUMMARY FOR STOCK MANAGEMENT" name="name2">
          <ConsignmentSummaryReportQtyTable :dataList="dataListQty" :periodDateStr="periodDateStr">
          </ConsignmentSummaryReportQtyTable>
        </TabPane>
        <TabPane label="RCV-RTV QTY DETAIL" name="name3">
          <ConsignmentSummaryReportRcvTable :dataList="dataListRcv" :periodDateStr="periodDateStr">
          </ConsignmentSummaryReportRcvTable>
        </TabPane>
      </Tabs>
    </Feature>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnModel">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AddMonths, AddWeeks, DateToString, MinusDays, Translate, DownloadFile, ExceptionHandling } from "@/util/common"
import ConsignmentSummaryReportAmtTable from '../../components/ConsignmentSummaryReportAmtTable.vue'
import ConsignmentSummaryReportQtyTable from '../../components/ConsignmentSummaryReportQtyTable.vue'
import ConsignmentSummaryReportRcvTable from '../../components/ConsignmentSummaryReportRcvTable.vue'
import ConsignmentSummaryReportAmtTableTH from '../../components/ConsignmentSummaryReportAmtTableTH.vue'
import GroupTitle from "@/views/default/GroupTitle"
import { AlertInfo } from "@/util/alert"

export default {
  name: "ConsignmentSummaryReport",
  components: {
    ConsignmentSummaryReportAmtTable,
    ConsignmentSummaryReportQtyTable,
    ConsignmentSummaryReportRcvTable,
    ConsignmentSummaryReportAmtTableTH,
    GroupTitle
  },
  created() {
    // 原本這寫法不可能拿到 getGroupCode 的 因為在 created 的時候還沒有 getGroupCode 就想判斷有沒有是不行的
    // 就先註解掉下面的啦
    // let vueInstance = this
    // if (vueInstance.getGroupCode()) {
    //   vueInstance.toggleLoading(true)
    //   vueInstance.$getPlantCode(vueInstance, vueInstance.getGroupCode().ecUuid).then(data => {
    //     vueInstance.toggleLoading(false)
    //     if (data) {
    //       data.forEach((plant) => {
    //         this.plantList.push(plant.objectKey)
    //       })
    //     } else {
    //       vueInstance.toggleLoading(false)
    //       AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
    //       })
    //       vueInstance.$router.push("/home")
    //     }
    //   })
    // } else {
    //   vueInstance.$router.push("/home")
    // }
  },
  watch: {
    getGroupCode: {
      immediate: true,
      handler(group) {
        if (!group) return
        this.fetchPlant(group.ecUuid)
      }
    }
  },
  data() {
    return {
      deltaPnModel: false,
      plantList: [],
      plantCode: '',
      deltaPnValue: '',
      validFrom: '',
      periodTypeValue: 'WEEKLY',
      periodTypeList: [
        {
          value: 'WEEKLY',
          label: 'Weekly'
        },
        {
          value: 'MONTHLY',
          label: 'Monthly'
        }
      ],
      currencyData: [],
      periodDateStr: '',
      dataListAmt: [],
      dataListAmtTH: [],
      dataListQty: [],
      dataListRcv: [],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getConsignmentSummaryStockDeltaPn", "getGroupCode"]),
    ...mapActions(["toggleLoading", "setConsignmentSummaryStockDeltaPn"]),
    moreDeltaPn() {
      this.deltaPnModel = true
      this.setConsignmentSummaryStockDeltaPn("")
    },
    confirmDeltaPnModel() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setConsignmentSummaryStockDeltaPn(this.getConsignmentSummaryStockDeltaPn().concat(a.trim() + ";"))
      })
      this.setConsignmentSummaryStockDeltaPn(this.getConsignmentSummaryStockDeltaPn().substr(0, this.getConsignmentSummaryStockDeltaPn().length - 1))
    },
    fetchPlant(ecUuid) {
      this.toggleLoading(true)
      this.$getPlantCode(this, ecUuid).then(data => {
        this.toggleLoading(false)
        if (data) {
          this.plantList = data.map(item => item.objectKey)
        } else {
          AlertInfo(this, this.$t('COMMON_MESSAGE_NOT_AUTH'))
        }
      })
    },
    search() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode, vueInstance.periodTypeValue)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => { })
        return
      }
      initDate(vueInstance)
      vueInstance.toggleLoading(true)
      Promise.all([
        searchSummaryReport(vueInstance),
        searchSummaryReportForInvoice(vueInstance)
      ]).then(messageList => {
        vueInstance.toggleLoading(false)
        errorMessage += messageList.join("")
        if (errorMessage) {
          AlertInfo(vueInstance, errorMessage).then(() => { })
        }
      })
    },
    download() {
      let vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode, vueInstance.periodTypeValue)

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$consignmentHttp
          .post("con-sum-rpt/export", JSON.stringify(buildCateria(vueInstance)),
            { responseType: 'blob' })
          .then((response) => {
            DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
          })
          .catch((error) => {
            console.log(error.response)
            let text = ExceptionHandling(error.response)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              html: text,
            })
            // vueInstance.$router.push("/home")
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    valid(plantCode, periodTypeValue) {
      let errorMessage = ""
      if (!plantCode) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PLANT_CODE') + " <br>"
      }
      if (!periodTypeValue) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PERIOD_TYPE') + " <br>"
      }
      return errorMessage
    },
    clear() {
      this.plantCode = ''
      this.deltaPn = ''
      this.deltaPnValue = ''
      this.validFrom = ''
      this.periodTypeValue = ''
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    changeDate() {
      this.setPeriodDate(this)
    },
    changePeriod(value) {
      this.periodTypeValue = value
      this.setPeriodDate(this)
    },
    setPeriodDate(vueInstance) {
      if (vueInstance.validFrom) {
        console.log(vueInstance.validFrom)
        let tempValidFrom = new Date(vueInstance.validFrom)
        console.log(tempValidFrom)
        let temp = DateToString(tempValidFrom, "-") + " ~ "
        if (vueInstance.periodTypeValue == 'MONTHLY') {
          vueInstance.periodDateStr = temp + DateToString(MinusDays(AddMonths(tempValidFrom, 1), 1), "-")
        } else if (vueInstance.periodTypeValue == 'WEEKLY') {
          vueInstance.periodDateStr = temp + DateToString(MinusDays(AddWeeks(tempValidFrom, 1), 1), "-")
        } else {
          vueInstance.periodDateStr = ""
        }
        console.log(vueInstance.validFrom)
        console.log(tempValidFrom)
      }
    }
  },
  computed: {
    getGroupCode() {
      return this.$store.getters.getGroupCode
    },
    modalSize() {
      return this.getModalSize()
    },
    deltaPn: {
      get() {
        return this.getConsignmentSummaryStockDeltaPn()
      },
      set(value) {
        this.dataList = []
        return this.setConsignmentSummaryStockDeltaPn(value)
      }
    },
  }
}

function searchSummaryReport(vueInstance) {
  return vueInstance.$consignmentHttp
    .post("/con-sum-rpt", JSON.stringify(buildCateria(vueInstance)))
    .then((response) => {
      let errorMessage = ""
      if (response.data) {
        if (!response.data.qtySummaryForStockManagementResult ||
          !response.data.qtySummaryForStockManagementResult.details ||
          response.data.qtySummaryForStockManagementResult.details.length == 0) {
          errorMessage += "QTY-SUMMARY FOR STOCK MANAGEMENT is empty <br>"
        } else {
          vueInstance.dataListQty = response.data.qtySummaryForStockManagementResult.details
        }
        if (!response.data.rcvRtvQtyDetailResult ||
          !response.data.rcvRtvQtyDetailResult.details ||
          response.data.rcvRtvQtyDetailResult.details.length == 0) {
          errorMessage += "RCV-RTV QTY DETAIL is empty <br>"
        } else {
          vueInstance.dataListRcv = response.data.rcvRtvQtyDetailResult.details
        }
      }
      return errorMessage
    })
    .catch(() => { })
}

function searchSummaryReportForInvoice(vueInstance) {
  return vueInstance.$consignmentHttp
    .post("/con-sum-rpt/invoice", JSON.stringify(buildCateria(vueInstance)))
    .then((response) => {
      let errorMessage = ""
      if (response.data) {
        if (response.data.amountSummaryForInvoiceResult &&
          response.data.amountSummaryForInvoiceResult.details &&
          response.data.amountSummaryForInvoiceResult.details.length > 0) {
          vueInstance.currencyData = response.data.amountSummaryForInvoiceResult.summaryList
          vueInstance.dataListAmt = response.data.amountSummaryForInvoiceResult.details
        } else if (response.data.amountSummaryForInvoiceThResult &&
          response.data.amountSummaryForInvoiceThResult.details &&
          response.data.amountSummaryForInvoiceThResult.details.length > 0) {
          vueInstance.currencyData = response.data.amountSummaryForInvoiceThResult.summaryList
          vueInstance.dataListAmtTH = response.data.amountSummaryForInvoiceThResult.details
        } else {
          errorMessage += "AMT-SUMMARY FOR INVOICE is empty <br>"
        }
      }
      return errorMessage
    })
    .catch(() => { })
}

function initDate(vueInstance) {
  vueInstance.currencyData = []
  vueInstance.dataListAmt = []
  vueInstance.dataListAmtTH = []
  vueInstance.dataListQty = []
  vueInstance.dataListRcv = []
}

function buildCateria(vueInstance) {
  let deltaPnArray = []
  vueInstance.getConsignmentSummaryStockDeltaPn().split(';').forEach(a => {
    deltaPnArray.push(a)
  })
  return {
    plant: vueInstance.plantCode,
    partNos: vueInstance.getConsignmentSummaryStockDeltaPn() == "" ? [] : deltaPnArray,
    periodType: vueInstance.periodTypeValue,
    fromDate: vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null
  }
}
</script>

<style scoped></style>
